import { connect } from 'react-redux';
import FlashMessages from 'es6/components/common/flash-messages';
import { getFlash } from 'es6/helpers/selectors';

function mapStateToProps(state) {
  return { flash: getFlash(state) };
}

export default connect(mapStateToProps)(FlashMessages);
